/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AcknowledgeTalentRecommendation } from '@coin/shared/core/util-models-v2';
import { CreateTalentRecommendation } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfTalentEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfTalentPool } from '@coin/shared/core/util-models-v2';
import { PageOfTalentReviewEmployee } from '@coin/shared/core/util-models-v2';
import { ReferenceMetaType } from '@coin/shared/core/util-models-v2';
import { TalentPoolAvailability } from '@coin/shared/core/util-models-v2';
import { TalentRecommendation } from '@coin/shared/core/util-models-v2';
import { TalentRecommendationRatio } from '@coin/shared/core/util-models-v2';
import { TalentReviewDashboardValues } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface GetFieldValuesTalentReviewsParams {
  queryAreCode?: string;
  queryTalentPoolTitle?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: string;
  queryReviewExcluded?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

export interface GetTalentReviewsParams {
  queryTalentPoolTitle?: Array<string>;
  queryReferenceMetaTypes?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  queryReviewExcluded?: Array<string>;
  queryAreCodes?: Array<string>;
  queryIsWildcardCandidate?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface GetTalentsParams {
  queryTalentPoolTitle?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryAreCodes?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface QueryFieldValuesTalentsParams {
  queryTalentPoolTitle?: string;
  queryOrgCode?: string;
  queryAreCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5;
}

export interface QueryTalentPoolsParams {
  queryTitle?: string;
  queryReferenceMetaTypes?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SuccessionManagementCustomerAcknowledgeTalentRecommendationsParams {
  id: string;
  approvalId: string;
  acknowledgeTalentRecommendation?: AcknowledgeTalentRecommendation;
}

export interface SuccessionManagementCustomerCreateTalentRecommendationsParams {
  createTalentRecommendation?: CreateTalentRecommendation;
}

export interface SuccessionManagementCustomerGetTalentRecommendationRatiosParams {
  orgCode?: string;
}

export interface SuccessionManagementCustomerQueryFieldValuesTalentRecommendationRatiosParams {
  targetProperty: 0;
  pagingPage?: number;
  pagingSize?: number;
  orgCode?: string;
}

export interface SuccessionManagementCustomerRevertTalentRecommendationsParams {
  id: string;
  approvalId: string;
}

@Injectable({
  providedIn: 'root'
})
export class SuccessionManagementCustomerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailabilityTalentPools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentPoolAvailability>;
  public getAvailabilityTalentPools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentPoolAvailability>>;
  public getAvailabilityTalentPools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentPoolAvailability>>;
  public getAvailabilityTalentPools(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talent-pools/availability`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesTalentReviews(
    requestParameters?: GetFieldValuesTalentReviewsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public getFieldValuesTalentReviews(
    requestParameters?: GetFieldValuesTalentReviewsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public getFieldValuesTalentReviews(
    requestParameters?: GetFieldValuesTalentReviewsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public getFieldValuesTalentReviews(
    requestParameters?: GetFieldValuesTalentReviewsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/review-talents/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.AreCode': requestParameters?.queryAreCode,
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.ReviewExcluded': requestParameters?.queryReviewExcluded,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        TargetProperty: requestParameters?.targetProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTalentReviews(
    requestParameters?: GetTalentReviewsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTalentReviewEmployee>;
  public getTalentReviews(
    requestParameters?: GetTalentReviewsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTalentReviewEmployee>>;
  public getTalentReviews(
    requestParameters?: GetTalentReviewsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTalentReviewEmployee>>;
  public getTalentReviews(requestParameters?: GetTalentReviewsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/review-talents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.ReferenceMetaTypes': requestParameters?.queryReferenceMetaTypes,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Search': requestParameters?.querySearch,
        'Query.TalentPoolId': requestParameters?.queryTalentPoolId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCodes': requestParameters?.queryOrgCodes,
        'Query.OrgNames': requestParameters?.queryOrgNames,
        'Query.RecommendationState': requestParameters?.queryRecommendationState,
        'Query.ReviewExcluded': requestParameters?.queryReviewExcluded,
        'Query.AreCodes': requestParameters?.queryAreCodes,
        'Query.IsWildcardCandidate': requestParameters?.queryIsWildcardCandidate,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTalents(
    requestParameters?: GetTalentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTalentEmployee>;
  public getTalents(
    requestParameters?: GetTalentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTalentEmployee>>;
  public getTalents(
    requestParameters?: GetTalentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTalentEmployee>>;
  public getTalents(requestParameters?: GetTalentsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Search': requestParameters?.querySearch,
        'Query.TalentPoolId': requestParameters?.queryTalentPoolId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Query.OrgCodes': requestParameters?.queryOrgCodes,
        'Query.OrgNames': requestParameters?.queryOrgNames,
        'Query.AreCodes': requestParameters?.queryAreCodes,
        'Query.RecommendationState': requestParameters?.queryRecommendationState,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTalents(
    requestParameters?: QueryFieldValuesTalentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesTalents(
    requestParameters?: QueryFieldValuesTalentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesTalents(
    requestParameters?: QueryFieldValuesTalentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesTalents(
    requestParameters?: QueryFieldValuesTalentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talents/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TalentPoolTitle': requestParameters?.queryTalentPoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.AreCode': requestParameters?.queryAreCode,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.PlaceOfAction': requestParameters?.queryPlaceOfAction,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        TargetProperty: requestParameters?.targetProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTalentPools(
    requestParameters?: QueryTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTalentPool>;
  public queryTalentPools(
    requestParameters?: QueryTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTalentPool>>;
  public queryTalentPools(
    requestParameters?: QueryTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTalentPool>>;
  public queryTalentPools(requestParameters?: QueryTalentPoolsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talent-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Title': requestParameters?.queryTitle,
        'Query.ReferenceMetaTypes': requestParameters?.queryReferenceMetaTypes,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerAcknowledgeTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public successionManagementCustomerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerAcknowledgeTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public successionManagementCustomerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerAcknowledgeTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public successionManagementCustomerAcknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerAcknowledgeTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const approvalId = requestParameters?.approvalId;
    this.checkRequired('successionManagementCustomerAcknowledgeTalentRecommendations', { id, approvalId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/succession-management/customer/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.acknowledgeTalentRecommendation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerCreateTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public successionManagementCustomerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerCreateTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public successionManagementCustomerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerCreateTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public successionManagementCustomerCreateTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerCreateTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/succession-management/customer/v1/talent-recommendations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createTalentRecommendation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerGetDashboardValuesTalentReviews(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentReviewDashboardValues>;
  public successionManagementCustomerGetDashboardValuesTalentReviews(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentReviewDashboardValues>>;
  public successionManagementCustomerGetDashboardValuesTalentReviews(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentReviewDashboardValues>>;
  public successionManagementCustomerGetDashboardValuesTalentReviews(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/review-talents/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerGetTalentRecommendationRatiosParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendationRatio>;
  public successionManagementCustomerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerGetTalentRecommendationRatiosParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendationRatio>>;
  public successionManagementCustomerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerGetTalentRecommendationRatiosParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendationRatio>>;
  public successionManagementCustomerGetTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerGetTalentRecommendationRatiosParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talent-recommendation-ratio`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrgCode: requestParameters?.orgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerQueryFieldValuesTalentRecommendationRatiosParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public successionManagementCustomerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerQueryFieldValuesTalentRecommendationRatiosParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public successionManagementCustomerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerQueryFieldValuesTalentRecommendationRatiosParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public successionManagementCustomerQueryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerQueryFieldValuesTalentRecommendationRatiosParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('successionManagementCustomerQueryFieldValuesTalentRecommendationRatios', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talent-recommendation-ratio/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        TargetProperty: targetProperty,
        OrgCode: requestParameters?.orgCode
      }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerQueryReferenceMetaTypesTalentPools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<ReferenceMetaType>>;
  public successionManagementCustomerQueryReferenceMetaTypesTalentPools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<ReferenceMetaType>>>;
  public successionManagementCustomerQueryReferenceMetaTypesTalentPools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<ReferenceMetaType>>>;
  public successionManagementCustomerQueryReferenceMetaTypesTalentPools(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/succession-management/customer/v1/talent-pools/reference-meta-types`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public successionManagementCustomerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerRevertTalentRecommendationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentRecommendation>;
  public successionManagementCustomerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerRevertTalentRecommendationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentRecommendation>>;
  public successionManagementCustomerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerRevertTalentRecommendationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentRecommendation>>;
  public successionManagementCustomerRevertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerRevertTalentRecommendationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const approvalId = requestParameters?.approvalId;
    this.checkRequired('successionManagementCustomerRevertTalentRecommendations', { id, approvalId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/succession-management/customer/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }
}
